import ENDPOINT from './ApiEndpoint';
import { adminAPI, authHeader } from './config';
import cleanObject from '../helper/cleanObject';

/**
 * Handle request server to get list of preshows
 * @param {*} param
 * @returns response
 */
export const getListPreshows = async ({
  key = '',
  status = '',
  offset = 0,
  limit = 10
}) => {
  const params = { key, offset, limit, status };
  const newParams = cleanObject(params, 'status');
  const response = await adminAPI.get(ENDPOINT.PRESHOWS, {
    params: newParams,
    headers: authHeader()
  });
  return response;
};

/**
 * Get preshow details with list of spots
 * @param {string} preshowId
 * @returns response
 */
export const getPreshowWithSpots = async ({ preshowId }) => {
  const response = await adminAPI.get(
    `${ENDPOINT.PRESHOWS}/${preshowId}/spots`,
    {
      headers: authHeader()
    }
  );
  return response;
};

export default getListPreshows;
